import { render } from "./CrisisDetails.vue?vue&type=template&id=4548335a&scoped=true"
import script from "./CrisisDetails.vue?vue&type=script&lang=js"
export * from "./CrisisDetails.vue?vue&type=script&lang=js"

import "./CrisisDetails.vue?vue&type=style&index=0&id=4548335a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4548335a"]])

export default __exports__